export default "__VITE_ASSET__CyfNtyLl__"